/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import {hashHistory} from 'react-router';
import {Form, Button, Modal, Input, Col, Row, message, Select, Table} from 'antd';
import {DmsTab, DataList, cityData, TableView} from 'Components';
import {getSubStoreList, getProductListIds, sundryOutStorage, getSendNo} from '../../service/product';
import {showSpin, hideSpin, openNotice} from 'Utils';

const confirm = Modal.confirm;

class SublibraryTransfer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: parseInt(this.props.params.channelId, 10),
            details: {},
            count: 1,
            count2: 1,
            number: 1,
            number2: 1,
            dataSource: [],
            dataSource2: [],
            nowStore: [],
            store: [],
            ids: [],
            targetStore: [],
            addRows: [],
            selectedRowKeys: [],
            selectedRemoveRowKeys: [],
            nowStoreId: '',
            addTotal: 1,
            rows: [],
            userName: '',
            productList: [],
            storageLocal: '',
            add: [],
            total: 1,
            selectedIndex: '',
            visible: false,
            addSearchObj: {
                name: '',
                code: '',
                s: 5,
                p: 1
            },
            cityData: cityData,
            brandData: [],
            options: [],//归属区域
            channels: [],//上级渠道
            employee: [],//所属业务员
            account_limitType: [],
            product_categoryTree: [], //产品类型
            dmsAddressNewVo: {},
            x: '',
            products: [],
            button_limits_end: {}
        };
        this.onChange = this.onChange.bind(this);
        this.openModal = this.openModal.bind(this);
    }

    componentWillMount() { //准备数据
    }

    componentDidMount() {
        this.mounted = true;
        let user = JSON.parse(window.localStorage.getItem('login_user_information'));
        getSubStoreList({
            removeFlag: 0,
            s: 10,
            p: 1,
        }).then((result) => {
            if (result && result.code == 200) {
                this.setState({
                    store: result.data || [],
                    targetStore: result.data || [],
                    total: result.total,
                    userName: user.userName
                })
            } else {
                openNotice('error', '数据获取失败', '');
            }
        })
        getSendNo().then(res => {
            // console.log(res);
            if (res && res.code == 200) {
                this.setState({sendNo: res.data})
            }
        })
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    //选择物料
    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({
            selectedRowKeys: selectedRowKeys,
            add: selectedRows
        })
    };
    changeTargetStore = (value) => {
        const self = this;
        confirm({
            content: '切换子库存将重置出库明细,确定吗?',
            onOk() {
                self.setState({dataSource2: [], storageLocal: value.key});
            },
            onCancel() {
                return
            }
        })

    };

    onChange = (value, index) => {
        return (value) => {
            const dataSource = [...this.state.dataSource];
            // console.log(dataSource);
            dataSource[index].county = value[2];
            dataSource[index].city = value[1];
            dataSource[index].province = value[0];

            this.setState({dataSource});
        };
    }

    cancelHandle() {
        hashHistory.goBack()
    }

    submitHandle() {
        let data = this.state.dataSource2;
        const productList = [];
        if (data.length === 0) {
            openNotice('warning', '请添加物料', '');
            return;
        }
        for (let i = 0; i < data.length; i++) {
            let obj = {
                storageLocal: this.state.storageLocal,
                num: data[i].num,
                productId: data[i].id,
                proType: data[i].type,
                remark: data[i].remark,
                sendNo: this.state.sendNo,
            };
            if (!obj.num) {
                openNotice('warning', data[i].code + '请输入出库数量', '');
                return;
            }
            if (obj.num < 0) {
                openNotice('warning', data[i].code + '出库数量必须大于0', '');
                return;
            }
            productList.push(obj);
        }
        sundryOutStorage(productList).then((result) => {
            if (result && result.code == 200) {
                openNotice('success', (result && result.message) ? result.message : '', '');
                hashHistory.goBack();
            } else {
                openNotice('error', (result && result.message) ? result.message : '', '');
            }
        })
    }

    //删除行
    deleteRemark = (record, index) => {
        let dataSource2 = this.state.dataSource2;
        dataSource2.splice(index, 1);
        for (let i = 0; i < this.state.ids.length; i++) {
            if (record.id == this.state.ids[i]) {
                this.state.ids.splice(i, 1);
                this.setState({ids: this.state.ids, dataSource2});
                return;
            }
        }
    }
    /*点击确定保存*/
    addSaveHandler = () => {
        /*确认*/
        this.doSave();
        /*清空信息*/
        this.doClear();
        this.setState({visible: false});
    };
    doSave = () => {
        let dataSource2 = this.state.dataSource2;
        this.setState({
            dataSource2: [...dataSource2, ...this.state.add],
            ids: [...this.state.ids, ...this.state.selectedRowKeys],
            visible: false
        });
    };
    doClear = () => {
        this.setState({
            name: '',
            code: '',
            add: [],
            selectedRowKeys: [],
        });
    };

    addSave(record) {
        const {ids} = this.state;
        if (ids.includes(record.id)) {
            openNotice('warning', '商品已添加');
            return
        }
        let dataSource2 = this.state.dataSource2;
        this.setState({
            dataSource2: [...dataSource2, record],
            ids: [...this.state.ids, record.id],
        })
    }

    //选择产品
    selectProduct = (record, index) => {
        if (!this.state.storageLocal || this.state.storageLocal == '') {
            openNotice('warning', '请选择目标仓库');
            return
        }
        this.productListIds();
        this.setState({selectedIndex: index, visible: true});
    };
    productListIds = () => {
        const {addSearchObj} = this.state;
        addSearchObj.substoreId = this.state.storageLocal || '';
        getProductListIds(addSearchObj).then((result) => {
            if (result && result.code == 200) {
                this.setState({
                    addRows: result.data || [],
                    addTotal: result.total
                });
            }
        })
    }
    addPageChange = (page) => {
        this.setState({
            addSearchObj: {...this.state.addSearchObj, p: page}
        }, () => {
            this.productListIds();
        });
    };
    changeValue = (e, type) => {
        this.setState({
            addSearchObj: {...this.state.addSearchObj, [type]: e.target.value}
        })
    };

    removeNumFn = (record, e) => {
        record.num = e.target.value;
    }

    remarkFn = (record, e) => {
        record.remark = e.target.value;
    }

    openModal() {
        this.productModal.showModal();
    }

    handleOk = () => {
        this.setState({visible: false});
    };
    handleCancel = () => {
        this.setState({visible: false});
    };

    render() {
        const {
            id, details, targetStore, visible, addRows, userName,
            addSearchObj, addTotal, dataSource2, selectedRowKeys, ids
        } = this.state;

        const productProps = {
            size: 'small',
            rowKey: 'id',
            dataSource: dataSource2,
            pagination: false,
            bordered: true,
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'code',
                }, {
                    title: '物料描述',
                    dataIndex: 'name',
                }, {
                    title: '物料类别',
                    dataIndex: 'proType',
                }, {
                    title: '单位',
                    dataIndex: 'unit',
                }, {
                    title: '装箱数',
                    dataIndex: 'packageQuantity',
                }, {
                    title: '目标仓库现有量',
                    dataIndex: 'currentNum',
                },
                {
                    title: '出库数量',
                    dataIndex: 'removeNum',
                    render: (text, record, index) => <Input type='Number' style={{width: '200px'}}
                                                            onChange={this.removeNumFn.bind(this, record)} min={0}/>
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    render: (text, record, index) => <Input type='String' style={{width: '200px'}}
                                                            onChange={this.remarkFn.bind(this, record)}/>
                },
                {
                    title: '操作',
                    dataIndex: '',
                    render: (text, record, index) => <span key={record.id}><a
                        onClick={this.deleteRemark.bind(this, record, index)}>删除</a></span>
                }
            ],
        };

        const cells = {
            createdDate: {
                title: '事物处理日期：',
                render: text => new Date().format('yyyy-MM-dd')
            },
            employeeText: {
                title: '操作员：',
                render: text => <span>{userName}</span>
            },
            storingStr: {
                title: '目标仓库：',
                text: '选择目标仓库',
                multiple: false,//支持多选
                type: 'select',
                render: text => (<Select
                        labelInValue
                        onChange={this.changeTargetStore.bind(this)}
                        style={{width: 200}}
                    >
                        {targetStore.map(function (item) {
                            return <Select.Option key={item.id + ''}
                                                  value={item.id + ''}>{item.subStoreName}</Select.Option>
                        })}
                    </Select>
                )
            },
            lastUpdatedDate: {
                title: '事物处理类型：',
                render: text => <span>杂项出库</span>
            },
            sendNo: {
                title: '事物编号：',
                render: text => <span>{this.state.sendNo}</span>
            },
        };
        const addProps = {
            rowKey: 'id',
            loading: false,
            pageParam: {
                total: addTotal,
                current: addSearchObj.p,//当前页码
                pageSize: addSearchObj.s,//当前分页数
                onChange: this.addPageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'code',
                    width: 100,
                }, {
                    title: '物料描述',
                    dataIndex: 'name',
                    width: 100
                }, {
                    title: '供应商',
                    dataIndex: 'supplier',

                }, {
                    title: '物料类别',
                    dataIndex: 'proType',
                }, {
                    title: '单位',
                    dataIndex: 'unit'
                }, {
                    title: '装箱数',
                    dataIndex: 'packageQuantity',

                }, {
                    title: '价格',
                    dataIndex: 'showPrice',
                    render: text => <span style={{color: '#d61518'}}>{'¥' + text}</span>
                }, /*{
                    title: '是否生效',
                    dataIndex: 'takeEffect',
                    render: text => text == 'Y' ? <span>是</span> : <span>否</span>
                },*/ {
                    title: '备注',
                    dataIndex: 'remark',

                }, {
                    title: '创建时间',
                    dataIndex: 'createdDate',
                },
                {
                    title: '操作',
                    dataIndex: 'save',
                    width: 100,
                    render: (text, record, index) => (
                        <Button style={{background: '#red'}} icon="plus"
                                onClick={this.addSave.bind(this, record)}>添加</Button>)
                }
            ],
            rows: addRows,
            /*rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange,
                getCheckboxProps: record => ({
                    disabled: ids.includes(record.id)
                })
            }*/
        };

        return <div className="dms-body">
            <DmsTab options={[`${id > 0 ? '编辑渠道' : '杂项出库'}`]} defaultKey={0}>
                {<Button onClick={this.cancelHandle.bind(this)}>返回</Button>}
                {<Button type='primary' onClick={this.submitHandle.bind(this)}>提交</Button>}
            </DmsTab>
            <div className="dms-table-box">
                <Form>
                    <div className="dms-table-box">
                        <DataList cells={cells} data={details}></DataList>
                    </div>
                </Form>
            </div>
            <DmsTab options={['出库明细']} defaultKey={0}>
                {<Button style={{position: 'absolute', top: 2, right: 5}} icon="plus"
                         onClick={this.selectProduct}>新增行</Button>}
            </DmsTab>
            <Table {...productProps} style={{background: '#fff'}}/>
            <Modal
                visible={visible}
                title="选择物料"
                onOk={this.addSaveHandler}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={1000}
                style={{top: 20}}
            >
                <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <Row>
                            <Col span={8}><label>物料名称：</label><Input style={{width: 200}}
                                                                         value={this.state.addSearchObj.name}
                                                                         onChange={(e) => {
                                                                             this.changeValue(e, 'name')
                                                                         }}/></Col>
                            <Col span={8}><label>物料编码：</label><Input style={{width: 200}}
                                                                         value={this.state.addSearchObj.code}
                                                                         onChange={(e) => {
                                                                             this.changeValue(e, 'code')
                                                                         }}/></Col>
                            <Col span={8}><Button onClick={this.productListIds}>搜索</Button></Col>
                        </Row>
                        <TableView {...addProps} bordered style={{marginTop: 10}}/>
                    </section>
                </div>
            </Modal>
        </div>
    }
}

export default Form.create()(SublibraryTransfer)


// WEBPACK FOOTER //
// ./src/routes/stockControl/sundryOutStorage.js